import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
// import { Form } from '@ant-design/compatible';

// import '@ant-design/compatible/assets/index.css';


import {
  Row,
  Col,
  Card,
  Checkbox,
  Input,
  Button,
  Select,
  Typography,
  Radio,
  Tag,
  Collapse,
  Tooltip,
} from 'antd';
import Papa from "papaparse";
import './ResultFound.css'
import bgImg from '../../../../../assets/icons/chart-colored-bg.png'
import CheckCircleIcon from "../../../../../assets/icons/check-circle.png";

import SaveCase from '../../SaveCaseV2/SaveCase'
import SymptomsQueryTags from '../SymptomsQueryTags/SymptomsQueryTags';
import { DownloadOutlined, FolderOpenFilled, FolderOpenOutlined, LinkOutlined, MailOutlined, RedEnvelopeOutlined } from '@ant-design/icons';
import CustomIcon from '../../../../../utils/components/CustomIcon/CustomIcon';
import Notification from '../../../../../utils/Notification';

const { Option } = Select;
const { Title, Text } = Typography;
const { Panel } = Collapse
const notification = new Notification()

export const GeneInfo = ({genes, total}) => {
  const omimIdClicked = (omimId) => {
    window.open(`http://omim.org/entry/${omimId}`, '_blank').focus();
  }

  const disorders = (gene) => {
    if (!gene.disorders) return null
    return gene.disorders.map(order => {
      let values = order.split(',');
      if (values.length > 0) {
        let lastValue = values[values.length - 1];
        let omimId = lastValue.match(/\d{6}/g);
        if (omimId) {
          let index = lastValue.indexOf(omimId[0]);
  
          let inheritances = '';
  
          if(gene.hasOwnProperty('_childDocuments_')) {
            const document = gene['_childDocuments_'].find(document => document.omimId === omimId[0]);
  
            if(document && document.inheritances)
              inheritances = document.inheritances.map(inheritance => inheritance.match(/\b\w/g).join('').toUpperCase()).join(', ');
          }
  
          return <li key={order}>
            {values.slice(0, values.length - 1).join(',')},
            {lastValue.substring(0, index)}
            {<a href={`http://omim.org/entry/${omimId}`} target="_blank" rel="noopener noreferrer">
              {omimId}
            </a>}
            {lastValue.substring(omimId[0].length + index)}
            {inheritances !== '' && <span className="green"> [{inheritances}]</span>}
          </li>
        }
      }
      return <li key={order}>{order}</li>
    });
  }
  
  const onClick = (geneId) => {
    window.open(`http://www.ncbi.nlm.nih.gov/entrez/query.fcgi?db=gene&cmd=Retrieve&dopt=full_report&list_uids=${geneId}`, '_blank').focus();
  }
  return (
    <div className="flex-vertical-gap">
      {
        genes.map((gene, index) => {
          return (
            <Card
              title={<div className="gene-title"><Title level={4} style={{ color: '#D65C5C', margin: 0 }}>{gene.omimDesc || gene.geneSymbol}</Title></div>}
              extra={<Tooltip title="View gene details"><CustomIcon name="LineArrowExpandWindow" color='#D65C5C' onClick={() => onClick(gene.geneId)} /></Tooltip>}
              style={index === genes.length - 1 ? { marginBottom: '24px' } : {}}
            >
              <div className="gene-info-container">
                <div>Chromosome: {gene.chromosome[0]}</div>
                <div>Gene ID: {gene.geneId}</div>
                {/* <div>Nuclear Type: {gene.disorders[0]}</div> */}
                <ul>{disorders(gene)}</ul>
              </div>
            </Card>
          )
        })
      }
    </div>

  )
}

const ResultFound = ({ total, genes, searchRecord }) => {
  const history = useHistory()
  const [showSaveCaseModal, setShowSaveCaseModal] = useState(false)
  const [caseVersion, setCaseVersion] = useState(null)

  const exportCSV = (data, filename = "data.csv") => {
    const csv = Papa.unparse(data); // Convert JSON to CSV
    const blob = new Blob([csv], { type: "text/csv" });
    const url = URL.createObjectURL(blob);
  
    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    notification.show('info', 'Data Exported');
  };

  const requestTest = () => {
    if (caseVersion !== null) {
      history.push(`/request-test?caseVersionId=${caseVersion.id}`)
    } else {
      history.push(`/request-test?searchRecordId=${searchRecord.id}`)
    }
  }

  const handleExportResults = () => {
    exportCSV(genes)
  }

  // callback on save case
  const onSave = (caseVersion) => {
    setCaseVersion(caseVersion)
    setShowSaveCaseModal(false)
  }

  const Tags = () => {
    const { ethnicity, age, gender, queryJSON } = searchRecord || {}

    return (
      <>
        <div className="custom-tag-container">
          <Tag className="custom-tag">{ethnicity}</Tag>
          <Tag className="custom-tag">{age}</Tag>
          <Tag className="custom-tag">{gender}</Tag>
        </div>
        <SymptomsQueryTags node={queryJSON} />
      </>
    )
  }

  return (
    <div className="flex-vertical-gap" style={{ gap: '16px' }}>
      <div className="gs-theme__container">
        <div id="result-found-info-div" className="position-relative" style={{ minHeight: "200px" }}>
          <img src={bgImg} alt="bg-img" className="position-absolute-top-right" />
          <div id="result-found-logo" className="gs-theme__icon-frame">
            <CustomIcon name="CheckCircle" width={40} height={40} color="#FFFFFF" />
            {/* <img src={CheckCircleIcon} alt='Application Logo' style={{ height: '40px', width: '40px' }} /> */}
          </div>
          <Title style={{ margin: 0, color: 'white' }} level={2}>{total} Potential Diseases Found</Title>
          <Title style={{ margin: 0, color: 'white' }} level={3}>Genetic Test Recommended</Title>
          <Button block onClick={requestTest} style={{ backgroundColor: "#D65C5C", color: "white", border: '1px solid #A23737' }}>
            Request Test
            <CustomIcon name="Mail" />
          </Button>
        </div>
        <div style={{ display: "flex", flexDirection: "column", gap: "16px", padding: '24px' }}>
          <Tags />
          <Button style={{ background: 'transparent' }} className="gs-theme__border" type="default" block onClick={handleExportResults}>
            Export Results
            <CustomIcon name="Download" />
          </Button>
          <Button style={{ background: 'transparent' }} className="gs-theme__border" type="default" block onClick={() => setShowSaveCaseModal(true)}>
            Save Case
            <CustomIcon name="OpenFolder" />
          </Button>
        </div>
       <SaveCase open={showSaveCaseModal} onClose={() => setShowSaveCaseModal(false)} onSave={onSave} searchRecord={searchRecord} />
      </div>
      <GeneInfo genes={ genes }/>
    </div>
  );
};

export default ResultFound;
